import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http'
import { Router } from '@angular/router'

import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // TODO rework or remove this later
        // if (err && err.status === 401 && !this.router.isActive('/login', true)) {
        //     console.error('Authentication error. Redirecting to login page.');
        //     this.router.navigate(['/logout']);
        // }
        return customHttpErrorHandler(err)
      }),
    )
  }
}

export function customHttpErrorHandler(error: HttpErrorResponse | ErrorEvent): Observable<any> {
  if (error instanceof ErrorEvent) {
    console.error('Error while response handling: ', error)
  }

  return throwError(error)
}
